import { from } from 'rxjs';
import { Epic, ActionsObservable } from 'redux-observable';
import { firebaseStore } from '../firebase';

import { LOAD_DESTINATION_SCHOOLS, DestinationAction, loadDestinationSchoolsSuccess, loadDestinationSchoolsFailure } from '../actions/DestinationActions';
import { StoreState } from '../types';
import { mergeMap, map, catchError, startWith, filter } from 'rxjs/operators';

const destinationLoadEpic: Epic<DestinationAction, DestinationAction, StoreState> = (action$, store) =>
    action$
        .ofType(LOAD_DESTINATION_SCHOOLS)
        .pipe(
            map(a => a.value),
            startWith(store.value.destination.loadDestinationId),
            filter(destinationId => !!destinationId),
            mergeMap(destinationId =>
                from(firebaseStore.collection(`search`).where('destinationId', '==', destinationId).get())
                .pipe(
                    map(snapshot => snapshot.docs.length > 0
                        ? loadDestinationSchoolsSuccess(destinationId as string, snapshot)
                        : loadDestinationSchoolsFailure(destinationId as string, new Error(`Destination ${destinationId} has no schools`))),
                    catchError(error => ActionsObservable.of(loadDestinationSchoolsFailure(destinationId as string, error)))
                )
            )
        );

export default destinationLoadEpic;